export default __webpack_public_path__ + "static/media/preguntasFrecuentes.f7db7265.svg";